<template>
  <section>
    <section class="full-screen">
      <div class="full-content" style="box-sizing:border-box;padding-top: 100px;">
        <History />
      </div>
    </section>
    <section class="w100" style="height: 600px;">
      <div class="m-w flex-col-center">
        <span class="font60 c3" style="margin-bottom: 45px;padding-top: 150px;">关于我们</span>
        <span class="c6 font24 lighter" style="text-indent: 48px; margin-bottom: 60px;">杭州几禾科技有限公司成立于2015年，立志成为国内最具开放性的智慧零售服务平台。2016年、2017年，几禾科技分别完成3轮融资，并与支付宝深度合作开发基于图像识别的无人零售智能终端，建设新零售的技术服务平台。</span>
        <span class="c6 font24 lighter" style="text-indent: 48px;">到2017年10月，几禾科技已经支撑了包括果小7便利小站、布丁酒店新便利、巨鹿集团无人超市在内的2000多个无人零售终端的日常运营，并在广州、成都、武汉、长沙等城市设立办事处或代理机构。</span>
      </div>
    </section>
    <section class="w100 bg-grey" style="height: 800px;">
      <div class="m-w flex-col-center">
        <span class="font60" style="padding-top: 90px;">联系我们</span>
        <div class="m-w w100 flex-between text-left font18 lighter c9" style="margin-top: 90px;">
          <div :class="{ 'connect-us':true, 'connect-on': connectSelected == $i } "
               v-for="(i,$i) in connects" :key="$i"
               @mouseover="onselected($i)">
            <div class="connect-intro">
              <span style="margin-bottom: 30px;" v-for="(item,$index) in i.text" :key="$i*10+$index">{{item}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <InnerFooter />
    <Footer />
  </section>
</template>

<script>
  import InnerFooter from '@/components/InnerFooter'
  import History from '@/components/History'
  import Footer from '@/components/Footer'

  export default {
    components: { InnerFooter,History,Footer},
    data() {
      return {
        connectSelected: 0,
        connects: [
          {
            text:[ '公司名称','杭州几禾科技有限公司',' 公司地址','浙江省杭州市拱墅区','和睦路525-1号' ],
          },
          {
            text:['咨询电话','400-603-7717','商务合作','0571-88016132',' 官方网址','guoxiaoqi.com'],
          },
          {
            text: ['微信公众号','guoxiao7','微博','guoxiao7']
          }
        ]
      }
    },
    methods:{
      onselected(index) {
        this.connectSelected = index;
      },
    }
  }
</script>

<style scoped>

  .connect-intro {
    display: inline;
  }

  .connect-intro span {
    display: block;
  }

  .connect-us {
    width: 320px;
    height: 450px;
    box-sizing: border-box;
    background-color: #fff;
    padding: 86px 0 0 65px;
  }

  .connect-on{
    background-color: #FF8E88;
    color: #fff;
  }

</style>



// WEBPACK FOOTER //
// src/pages/AboutUs/index.vue